
import {createAsyncThunk} from '@reduxjs/toolkit'
import { getEmployment } from 'sr/utils/api/masterData/employment/getEmployment'
export const fetchEmployment = createAsyncThunk(
  'employment',
  async () => {
    const response = await getEmployment()
    return response?.data
  }
)


